import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/ui/other/webp/burger-menu-link-radioguide-rent.webp")